import { User } from "../../types/api/users";

/* 
Нельзя разрешить одновременное выделение 
пользователей с разным статусом
*/
export class CheckUserStatus {
  private users: User[];

  constructor(data: User[]) {
    this.users = data;
  }

  isBlocked = (userId: string, isBlocked: boolean): boolean => {
    const user = this.users.find((u) => u.id === userId);
    return user?.isBlocked === isBlocked;
  };

  allBlockedStatus = (userIds: string[], isBlocked: boolean) => {
    return userIds.every((id) => {
      const user = this.users.find((u) => u.id === id);
      return user?.isBlocked === isBlocked;
    });
  };

  isAllUsersStatusEqual = (): boolean => {
    if (this.users.length === 0 || this.users.length === 1) {
      return true;
    }
    const firstUserStatus = this.users[0].isBlocked;

    return this.users.every((user) => user.isBlocked === firstUserStatus);
  };
}
